//@description 公共方法提取
//@author wlj
import store from "@/store";
import router from "@/router";
import { Message, MessageBox } from 'element-ui'

const commonFunc = {};

// 门库列表背景图format --- type：行业资讯=1
commonFunc.imageFormat = (info, type) => {
  let d_Image1 = require('../assets/images/default_map_news.png'); // 行业咨询默认图
  if(type == 2) {
    return info ? info.split(',')[0] : ''
  }else {
    return info ? info : type == 1 ? d_Image1 : '';
  }
}

export default commonFunc;